require('./draganddrop');
module.exports = 'ang-drag-drop';



//////////////////
// WEBPACK FOOTER
// ./~/angular-native-dragdrop/index.js
// module id = 61
// module chunks = 0